import { GetterTree } from 'vuex'
import { IRootState, IProductsState, IPlan } from '@/@types'

const getters: GetterTree<IProductsState, IRootState> = {
  plansByTerm: state => {
    return state.availablePlans.reduce(
      (
        acc: { yearly: Array<IPlan>; monthly: Array<IPlan>; quarterly: Array<IPlan> },
        plan: IPlan
      ) => {
        switch (plan.term) {
          case 'month':
            acc.monthly.push(plan)
            break
          case 'quarterly':
            acc.quarterly.push(plan)
            break
          default:
            acc.yearly.push(plan)
            break
        }
        return acc
      },
      { yearly: [], monthly: [], quarterly: [] }
    )
  },
  availableProductBundles: state => {
    return state.availableProductBundles
  },
  availableCertifications: state => {
    return state.availableCertifications
  },
  availablePlans: state => {
    return state.availablePlans
  },
  availableLiveVirtualTrainings: state => {
    return state.availableLiveVirtualTrainings
  },
  getPlanCodes: state => {
    return state.planCodes
  },
  availableMerchantIds: state => {
    const planMerchantIds = state.availablePlans.map(plan => plan.merchant_id)
    const certMerchantIds = state.availableCertifications.map(cert => cert.merchant_id)
    const bundleMerchantIds = state.availableProductBundles.map(bundle => bundle.merchant_id)
    const lvtMerchantIds = state.availableLiveVirtualTrainings.map(lvt => lvt.merchant_id)
    return Array.from(
      new Set([...planMerchantIds, ...certMerchantIds, ...bundleMerchantIds, ...lvtMerchantIds])
    )
  },
  isOnePlanAvailable: state => {
    return state.isOnePlanAvailable
  },
}

export default getters
